/* static/table_engine_src/plugins/truncated_header_tooltips.js
   Add title tooltips to headers only when the label is truncated.
*/

"use strict";

function install(tableId) {
  const table = document.getElementById(tableId);
  if (!table) return () => {};

  const getLabelEl = (th) => {
    if (!th) return null;
    return (
      th.querySelector(":scope > .te-col-label") ||
      th.querySelector(".te-col-label") ||
      th
    );
  };

  const apply = () => {
    const ths = table.querySelectorAll("thead th, thead td");
    ths.forEach((th) => {
      const labEl = getLabelEl(th);
      const label = (labEl?.textContent || th.textContent || "").trim();
      if (!label) return;

      const cw = labEl?.clientWidth || 0;
      const sw = labEl?.scrollWidth || 0;
      if (!(cw > 0) || !(sw > 0)) return;

      const truncated = sw > cw + 1;
      if (truncated) {
        th.setAttribute("title", label);
        if (labEl && labEl !== th) labEl.setAttribute("title", label);
      } else {
        th.removeAttribute("title");
        if (labEl && labEl !== th) labEl.removeAttribute("title");
      }
    });
  };

  const scheduleApply = () => requestAnimationFrame(() => requestAnimationFrame(apply));
  scheduleApply();

  window.addEventListener("resize", apply, { passive: true });

  let ro = null;
  try {
    if (window.ResizeObserver) {
      ro = new ResizeObserver(() => apply());
      const thead = table.querySelector("thead");
      if (thead) ro.observe(thead);
    }
  } catch {}

  apply.__dispose = () => {
    try { window.removeEventListener("resize", apply); } catch {}
    try { ro?.disconnect?.(); } catch {}
  };

  return apply;
}

export const TableEngineTruncatedHeaderTooltips = Object.freeze({ install });
export default TableEngineTruncatedHeaderTooltips;